import styled from 'styled-components';
import { pickThemeColor, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { Tabs } from 'antd';

export const StyledTabs = styled(Tabs)`
  ${pickThemeFontStyles('12', '12')};
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;

  & .anticon {
    font-size: ${pickThemeFontSize('14')};
  }

  .ant-tabs-nav {
    width: 100%;
    margin-bottom: 0;

    &::before {
      border-bottom: 1px solid ${pickThemeColor('GRAY_STATUS_SECONDARY')};
    }
  }

  .ant-tabs-content-holder {
    padding-inline: 1.75rem;
    width: 100%;
  }

  .ant-tabs-nav-wrap {
    margin-inline: 1.75rem;
  }

  &&& .ant-tabs-tab-btn {
    ${pickThemeFontStyles('16', '20', 'NORMAL')};
    color: ${pickThemeColor('GRAY_STATUS')};

    :active {
      color: ${pickThemeColor('ORANGE_PRIMARY')};
    }
  }

  &&& .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      ${pickThemeFontStyles('16', '20', 'BOLD')};
      color: ${pickThemeColor('ORANGE_PRIMARY')};
    }
  }
  .ant-tabs-ink-bar {
    background-color: ${pickThemeColor('ORANGE_PRIMARY')} !important;
  }
`;
